/**
 * Registry of modal handles that close on browser back instead of navigating.
 * Populated by @CloseModalOnBrowserBack() when modal component classes are loaded.
 */
export const MODAL_CLOSE_ON_BACK_HANDLES = new Set<string>();

export function isCloseOnBackHandle(handle: string): boolean {
  return MODAL_CLOSE_ON_BACK_HANDLES.has(handle);
}
